import { useEffect, useRef } from 'react';

const DOTS_COUNT = 8;
const COLORS = ['#21c294', '#1ab386', '#009f7f', '#bad6fc', '#8ab4e8'];

export default function TranslateDots() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    track.innerHTML = '';
    const dots: HTMLDivElement[] = [];

    for (let i = 0; i < DOTS_COUNT; i++) {
      const dot = document.createElement('div');
      const size = 6 + Math.random() * 6;
      Object.assign(dot.style, {
        width: size + 'px',
        height: size + 'px',
        borderRadius: '50%',
        background: COLORS[i % COLORS.length],
        opacity: '0',
        position: 'absolute',
        top: '50%',
        left: '0%',
        transform: 'translateY(-50%)',
      });
      track.appendChild(dot);
      dots.push(dot);
    }

    let rafId: number;
    const animate = (t: number) => {
      const tSec = t / 1000;
      dots.forEach((dot, i) => {
        // Each dot has its own speed and phase — they travel left→right across the track
        const speed = 0.15 + (i % 3) * 0.05; // vary speed per dot
        const phase = i * 1.3;
        // x goes from 0% to 100%, wrapping around
        const progress = (tSec * speed + phase) % 1;
        const x = progress * 100;
        // slight vertical wave
        const y = Math.sin(tSec * 2 + phase) * 8;
        // fade in at edges, full in middle
        const edgeFade = Math.min(progress * 5, (1 - progress) * 5, 1);
        const opacity = 0.3 + 0.7 * edgeFade;

        dot.style.left = `${x}%`;
        dot.style.transform = `translateY(calc(-50% + ${y}px))`;
        dot.style.opacity = String(opacity);
      });
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div ref={trackRef} className="relative h-12 w-36 mx-auto overflow-hidden" aria-hidden="true" />
  );
}
